import { enqueuePaintScenarioCanvasActionTypes } from 'uf-api/api/paint.service';

export default function paintPending(state = false, action) {
  switch (action.type) {
    case enqueuePaintScenarioCanvasActionTypes.LOAD:
      return true;
    case enqueuePaintScenarioCanvasActionTypes.SUCCESS:
    case enqueuePaintScenarioCanvasActionTypes.FAILURE:
      return false;
    default:
      return state;
  }
}
